import { useEffect, useState } from "react";

import { useIntl } from "react-intl";

import { useUserContext } from "@/components/user-context";
import { useLocalizedHref } from "@/libraries/web-framework";
import { LogoV2 } from "@/libraries/wpl/foundations/src";
import { ProductPageSubNav } from "@/patterns/global-nav/src";

import { useJiraSitesContext } from "../jira-sites-provider/jira-sites-provider";

const JiraLogo = () => <LogoV2 brand="jira" type="logo" appearance="brand" />;

const SoftwareJiraLoggedInNavbar = () => {
    const intl = useIntl();
    const logoUrl = useLocalizedHref("/software/jira");
    const { profile } = useUserContext();
    const { jiraSitesFromAgg } = useJiraSitesContext();
    const [siteUrl, setSiteUrl] = useState("");

    useEffect(() => {
        const site = profile?.attributes?.existingSites[0];
        let tempSiteUrl = site?.url;
        if (jiraSitesFromAgg?.jira.allJiraProjects.edges.length === 1) {
            tempSiteUrl =
                jiraSitesFromAgg?.jira.allJiraProjects?.edges[0]?.node?.webUrl;
        }
        setSiteUrl(tempSiteUrl ?? "");
    }, [
        jiraSitesFromAgg?.jira.allJiraProjects.edges,
        jiraSitesFromAgg?.jira.allJiraProjects.edges.length,
        profile?.attributes?.existingSites,
        profile?.attributes?.existingSites.length
    ]);

    const goToLoggedInJira = () => {
        window.location.assign(siteUrl);
    };

    return (
        <ProductPageSubNav
            productLogoUrl={logoUrl}
            productLogo={<JiraLogo />}
            productLogoAriaLabel={intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            })}
            mobileCtaText={intl.formatMessage({
                id: "JiraSoftwarePageTemplate.navbar.goToJira",
                defaultMessage: "Go to Jira"
            })}
            mobileCtaOnClick={goToLoggedInJira}
            mobileLogo={<JiraLogo />}
            navigationTrynowCtaText={intl.formatMessage({
                id: "JiraFeatureSoftwarePageTemplate.navbar.goToJira",
                defaultMessage: "Go to Jira"
            })}
            navigationTrynowCtaOnClick={goToLoggedInJira}
            productPageNavLinks={[]}
            mobileLinksSections={[]}
            isShowSearchButton={false}
            isShowAppSwitcher={false}
            isShowTabletDropdown={false}
        />
    );
};

export default SoftwareJiraLoggedInNavbar;
